import React, { useEffect, useState, useRef } from 'react';
import './round-score.scss';
import { useIntl } from 'react-intl';

import RoundScoreLine from './round-score-line/round-score-line';
import RoundScoreContra from './round-score-contra/round-score-contra';
import PrimaryRibbon from '../../../../components/ribbons/primary.ribbon';
import { groupByType } from '../../../../helpers/groupBy.helper';
import { useSelector } from 'react-redux';
import RoundScoreOrder from './round-score-order/round-score-order';

function getContractStatusForTeam(intl, data, team) {
    const normalized = {
        text: '',
        type: 1,
    };
    const contra = data.multiplyFactors.contraX2;
    const recontra = data.multiplyFactors.contraX4;
    const contractTeam = data.contractTeam;
    const contractStatus = data.contractStatus;

    if (contra === false && recontra === false) {
        if (team === 0) {
            if (contractTeam === 0) {
                if (contractStatus === true) {
                    normalized.text = intl.messages.we_won;
                    normalized.type = 3;
                } else if (contractStatus === false) {
                    normalized.text = intl.messages.we_lost;
                    normalized.type = 1;
                }
            } else {
                if (contractStatus === true) {
                    normalized.text = intl.messages.they_won;
                    normalized.type = 3;
                } else if (contractStatus === false) {
                    normalized.text = intl.messages.they_lose;
                    normalized.type = 1;
                }
            }
        } else {
            if (contractTeam === 0) {
                if (contractStatus === true) {
                    normalized.text = intl.messages.they_won;
                    normalized.type = 3;
                } else if (contractStatus === false) {
                    normalized.text = intl.messages.they_lose;
                    normalized.type = 1;
                }
            } else {
                if (contractTeam === 1 && contractStatus === true) {
                    normalized.text = intl.messages.we_won;
                    normalized.type = 3;
                } else if (contractTeam === 1 && contractStatus === false) {
                    normalized.text = intl.messages.we_lost;
                    normalized.type = 1;
                }
            }
        }
    }
    if (contra === true && recontra === false) {
        if (team === 0) {
            if (contractTeam === 0) {
                if (contractStatus === true) {
                    normalized.text = intl.messages.contra_won;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.contra_lose;
                    normalized.type = 2;
                }
            } else {
                if (contractStatus === true) {
                    normalized.text = intl.messages.contra_lose;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.contra_won;
                    normalized.type = 2;
                }
            }
        } else {
            if (contractTeam === 0) {
                if (contractStatus === true) {
                    normalized.text = intl.messages.contra_lose;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.contra_won;
                    normalized.type = 2;
                }
            } else {
                if (contractStatus === true) {
                    normalized.text = intl.messages.contra_won;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.contra_lose;
                    normalized.type = 2;
                }
            }
        }
    }
    if (contra === true && recontra === true) {
        if (team === 0) {
            if (contractTeam === 0) {
                if (contractStatus === true) {
                    normalized.text = intl.messages.recontra_won;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.recontra_lose;
                    normalized.type = 2;
                }
            } else {
                if (contractStatus === true) {
                    normalized.text = intl.messages.recontra_lose;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.recontra_won;
                    normalized.type = 2;
                }
            }
        } else {
            if (contractTeam === 0) {
                if (contractStatus === true) {
                    normalized.text = intl.messages.recontra_lose;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.recontra_won;
                    normalized.type = 2;
                }
            } else {
                if (contractStatus === true) {
                    normalized.text = intl.messages.recontra_won;
                    normalized.type = 2;
                } else {
                    normalized.text = intl.messages.recontra_lose;
                    normalized.type = 2;
                }
            }
        }
    }
    return normalized;
}

const RoundScore = ({ data, closeRoundScore, closeRoundGameEnd, team }) => {
    const intl = useIntl();
    const [countTimer, setCountTimer] = useState(5);
    const timeoutRef = useRef();
    useEffect(() => {
        if (countTimer === 0 && typeof closeRoundScore === 'function') {
            clearTimeout(timeoutRef.current);
            closeRoundScore();
            if (data.gameEnded) {
                closeRoundGameEnd();
            }
            return;
        }

        timeoutRef.current = setTimeout(() => {
            setCountTimer(countTimer - 1);
        }, 1000);
    }, [countTimer]);

    const myGrouped = groupByType(
        data && data.extraScore && data.extraScore[0]
    );

    const secondGrouped = groupByType(
        data && data.extraScore && data.extraScore[1]
    );
    console.log('data', data);
    console.log('myGrouped', myGrouped);
    console.log('secondGrouped', secondGrouped);
    console.log('teamOfData', team);

    const contractStatusForTeam = getContractStatusForTeam(intl, data, team);

    const { contraX2 } = data.multiplyFactors;

    return (
        <div className="round_score">
            <div className="round_score_contract">
                <PrimaryRibbon
                    text={contractStatusForTeam.text}
                    type={contractStatusForTeam.type}
                />
            </div>
            <div className="round_score_content">
                <table className="round_score_table_content">
                    <RoundScoreLine scoreUs={'we'} scoreThem={'them'} />
                    {data.multiplyFactors.contraX2 === true && (
                        <RoundScoreContra
                            text={intl.messages.roundScore.order}
                            scoreContra={data.multiplyFactor}
                            scoreContraValue={data.contractValue}
                        />
                    )}
                    {!contraX2 && (
                        <RoundScoreOrder
                            text={intl.messages.roundScore.order}
                            value={data.contractValue}
                            contractTeam={data.contractTeam}
                            team={team}
                        />
                    )}
                    <RoundScoreLine
                        text={intl.messages.roundScore.taken}
                        team={team}
                        scoreUs={`${data.collectedScore[team === 0 ? 0 : 1]} (${
                            data.collectedScore[team === 0 ? 2 : 3]
                        })`}
                        scoreThem={`${
                            data.collectedScore[team === 0 ? 1 : 0]
                        } (${data.collectedScore[team === 0 ? 3 : 2]})`}
                    />

                    <RoundScoreLine
                        text={intl.messages.roundScore.tierce}
                        valueUs={
                            team === 0
                                ? myGrouped?.tierce
                                : secondGrouped?.tierce
                        }
                        valueThem={
                            team === 0
                                ? secondGrouped?.tierce
                                : myGrouped?.tierce
                        }
                        team={team}
                    />
                    <RoundScoreLine
                        text={intl.messages.roundScore.blot}
                        valueUs={
                            team === 0 ? myGrouped?.blot : secondGrouped?.blot
                        }
                        valueThem={
                            team === 0 ? secondGrouped?.blot : myGrouped?.blot
                        }
                        team={team}
                    />
                    <RoundScoreLine
                        text={'100 / 50'}
                        valueUs={
                            team === 0
                                ? myGrouped?.quarte
                                : secondGrouped?.quarte
                        }
                        valueThem={
                            team === 0
                                ? secondGrouped?.quarte
                                : myGrouped?.quarte
                        }
                        team={team}
                    />
                    <RoundScoreLine
                        text={'4x'}
                        valueUs={
                            team === 0 ? myGrouped['4x'] : secondGrouped['4x']
                        }
                        valueThem={
                            team === 0 ? secondGrouped['4x'] : myGrouped['4x']
                        }
                        team={team}
                    />
                    <RoundScoreLine
                        text={intl.messages.roundScore.total}
                        scoreUs={data.roundScore[team === 0 ? 0 : 1]}
                        scoreThem={data.roundScore[team === 0 ? 1 : 0]}
                        team={team}
                    />
                </table>
            </div>
            <span className="start_new_game">
                New game will start in {countTimer}
            </span>
        </div>
    );
};

export default RoundScore;
